angular.module('zc.projects')

.directive 'campaignListView', [ "$state", "Campaign", "Devise", ($state, Campaign, Devise) ->
  return {
    restrict: 'A'
    require: '?ngModel'
    scope: {
      showsButtons: "=showsButtons"
      campaign: "=ngModel"
      onCopy: "&"
      onDestroy: "&"
      filters: "="
      project: "="
    }
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_list.html'

    compile: (tElem, attrs) ->
      return (scope, element, attrs) ->
        scope.Campaign = Campaign
        scope.Devise = Devise

        scope.showCampaign = (campaignId) ->
          $state.go 'admin.projects.campaigns.show.stats', { projectId: $state.params.projectId, campaignId: campaignId }

        scope.editCampaign = (campaignId) ->
          $state.go 'admin.projects.campaigns.edit', { projectId: $state.params.projectId, campaignId: campaignId }

        scope.copyCampaign = () ->
          scope.onCopy(scope.campaign)

        scope.destroyCampaign = () ->
          scope.onDestroy(scope.campaign)

  }

]



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_list_view.js.coffee